import { Decimal } from '@paguz/contracts';
import { cn } from '@paguz/ui';

/** Porcentaje entero (0–100) para presentación desde un string decimal de la API. */
export function percentOf(value: string): number {
  try {
    return Decimal.min(100, Decimal.max(0, new Decimal(value)))
      .toDecimalPlaces(0)
      .toNumber();
  } catch {
    return 0;
  }
}

/** Barra de avance (local: `@paguz/ui` aún no tiene `Progress`, ver Solicitudes). */
export function ProgressBar({
  value,
  label,
  className,
}: {
  /** 0–100. */
  value: number;
  label: string;
  className?: string;
}) {
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      className={cn('h-2 w-full overflow-hidden rounded-full bg-muted', className)}
    >
      <div
        className="h-full rounded-full bg-highlight transition-[width] duration-500 ease-out"
        style={{ width: `${String(value)}%` }}
      />
    </div>
  );
}
